// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.NewImportResults__container___zbtAg {
    overflow: auto;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}

.NewImportResults__wrapper___baO8e {
    display: flex;
    margin: 0.8rem 1.2rem;
}

/* stylelint-disable-next-line selector-class-pattern -- Класс Consta */
.NewImportResults__searchCollapseBody___D5ZlW .Collapse-Body.Collapse-Body_isOpen {
    max-height: 0;
}

.NewImportResults__buttonsRow___jE0ih {
    display: flex;
    align-items: center;

    margin-right: 1.2rem;
    margin-bottom: 0.8rem;
    margin-left: 1.2rem;
}

.NewImportResults__text___fXw_n {
    flex-grow: 1;
}

.NewImportResults__filter___HIkEC {
    margin-top: 0.8rem;
    margin-right: 1.2rem;
    margin-left: 1.2rem;
}

.NewImportResults__resetFilter___KUtF2 {
    margin-left: 1.2rem;
}

.NewImportResults__stateLoading___lOwiY {
    display: flex;
    flex-grow: 1;
    align-items: center;
}

.NewImportResults__notFound___yDexz,
.NewImportResults__serverError___RXGiK {
    display: flex;
    flex-grow: 1;
}
`, "",{"version":3,"sources":["webpack://./src/core/pages/Project/OverallImport/NewImportResults/NewImportResults.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA,uEAAuE;AACvE;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;;IAEnB,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;IAEI,aAAa;IACb,YAAY;AAChB","sourcesContent":[".container {\n    overflow: auto;\n    display: flex;\n    flex-direction: column;\n    flex-grow: 1;\n}\n\n.wrapper {\n    display: flex;\n    margin: 0.8rem 1.2rem;\n}\n\n/* stylelint-disable-next-line selector-class-pattern -- Класс Consta */\n.searchCollapseBody :global(.Collapse-Body.Collapse-Body_isOpen) {\n    max-height: 0;\n}\n\n.buttonsRow {\n    display: flex;\n    align-items: center;\n\n    margin-right: 1.2rem;\n    margin-bottom: 0.8rem;\n    margin-left: 1.2rem;\n}\n\n.text {\n    flex-grow: 1;\n}\n\n.filter {\n    margin-top: 0.8rem;\n    margin-right: 1.2rem;\n    margin-left: 1.2rem;\n}\n\n.resetFilter {\n    margin-left: 1.2rem;\n}\n\n.stateLoading {\n    display: flex;\n    flex-grow: 1;\n    align-items: center;\n}\n\n.notFound,\n.serverError {\n    display: flex;\n    flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `NewImportResults__container___zbtAg`,
	"wrapper": `NewImportResults__wrapper___baO8e`,
	"searchCollapseBody": `NewImportResults__searchCollapseBody___D5ZlW`,
	"buttonsRow": `NewImportResults__buttonsRow___jE0ih`,
	"text": `NewImportResults__text___fXw_n`,
	"filter": `NewImportResults__filter___HIkEC`,
	"resetFilter": `NewImportResults__resetFilter___KUtF2`,
	"stateLoading": `NewImportResults__stateLoading___lOwiY`,
	"notFound": `NewImportResults__notFound___yDexz`,
	"serverError": `NewImportResults__serverError___RXGiK`
};
export default ___CSS_LOADER_EXPORT___;
